export const manualResultValidationErrors: { [key: string]: string } = {
  HAEMOGLOBIN_VALUE_INVALID:
    "Haemoglobin should be inputted in g/l using the following format produced by the liberty device (XXX)",
  NEUTROPHILS_VALUE_INVALID: "Neutrophils should be inputted in (g/l) using the following format (XX.X)",
  PLATELETS_VALUE_INVALID: "Platelet count should be inputted in the (10⁹/L) using the following format (XXX)",
  WHITE_BLOOD_CELLS_VALUE_INVALID:
    "White blood cell count should be inputted in (10⁹/L) using the following format (XX.X)",
  DATE_RECORDED_AFTER_NOW_INVALID: "Test date is in the future",
  DATE_RECORDED_BEFORE_ZERO_DAY_INVALID: "Test date is too far in the past",
};
